import { InjectionToken } from "@angular/core";

export const MJX_TABLE_PAGE_SIZES = new InjectionToken<string>('Default page sizes for mjx table pagination', {
  providedIn: 'root',
  factory: () => null
});
